
// @ts-nocheck
export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    href: {
      type: String,
      default: null,
    },
    btnClass: {
      type: String,
      default: "",
    },
    block: {
      type: Boolean,
      default: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "primary",
    },
    isDepressed: {
      type: Boolean,
      default: true,
    },
    isOutlined: {
      type: Boolean,
      default: null,
    },
    isLoaded: {
      type: Boolean,
      default: false,
    },
    isDark: {
      type: Boolean,
      default: false,
    },
    isLarge: {
      type: Boolean,
      default: false,
    },
    isXLarge: {
      type: Boolean,
      default: false,
    },
    isRounded: {
      type: Boolean,
      default: false,
    },
    isJustify: {
      type: Boolean,
      default: null,
    },
    justify: {
      type: String,
      default: "center",
    },
    spanClass: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    iconPrepend: {
      type: Boolean,
      default: false,
    },
    iconClass: {
      type: String,
      default: "",
    },
    iconSize: {
      type: String,
      default: null,
    },
    iconStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    submit() {
      this.$emit("formSubmit");
    },
  },
};
